import { Checkbox } from '@mui/material';
import { muiStyles } from 'utils/design';
import React from 'react';
import { useFormikContext } from 'formik';

const useStyles = muiStyles(() => ({
  root: {
    padding: '1px',
    color: '#333',
  },
}));

interface FormCheckboxCellParams {
  data: any;
  fieldName: string;
  getRowId: (row: any) => string;
}

/**
 * Generic checkbox cell for grids inside a Formik Form.
 * Reads/writes a string[] field in Formik state — no AG Grid selection involved.
 */
export const FormCheckboxCell: React.FC<FormCheckboxCellParams> = ({ data, fieldName, getRowId }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<Record<string, string[]>>();

  if (!data) {
    return null;
  }

  const id = String(getRowId(data));
  const current = new Set((values[fieldName] || []).map(String));
  const checked = current.has(id);

  const toggle = () => {
    const next = new Set((values[fieldName] || []).map(String));
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setFieldValue(fieldName, Array.from(next));
  };

  return (
    <Checkbox
      color="primary"
      classes={classes}
      checked={checked}
      onChange={toggle}
      disableRipple
    />
  );
};
